var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0.25px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #ffbe00;\n      }\n\n      .cls-2, .cls-5 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #ffbe00;\n      }\n\n      .cls-4 {\n        stroke: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Img_download",
    "data-name": "Img download",
    transform: "translate(-22.715 -403.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18708",
    "data-name": "Rectangle 18708",
    className: "cls-1",
    transform: "translate(22.715 403.715)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 20,
    height: 24,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 0.125,
    y: 0.125,
    width: 19.75,
    height: 23.75,
    rx: 0.875
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18975",
    "data-name": "Rectangle 18975",
    className: "cls-2",
    transform: "translate(23.715 404.715)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 18,
    height: 17.999
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 16.999
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_43796",
    "data-name": "Path 43796",
    className: "cls-3",
    d: "M-4092.486,1151.251a1.655,1.655,0,0,1-1.636-1.673v-.5l4.223-4.169a.806.806,0,0,1,1.157.021l2.066,2.187,5.286-5.218a.806.806,0,0,1,1.157.021l4.111,4.351v3.312a1.655,1.655,0,0,1-1.636,1.673Z",
    transform: "translate(4117.837 -728.944)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_417",
    "data-name": "Ellipse 417",
    className: "cls-3",
    cx: 1.35,
    cy: 1.35,
    rx: 1.35,
    ry: 1.35,
    transform: "translate(26.415 408.316)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDownload);
export default __webpack_public_path__ + "static/media/imgDownload.b84e9eaa711da9a38a2c41a9a400267b.svg";
export { ForwardRef as ReactComponent };